export const leadDetailConstants = {
  FETCH_LEAD: 'FETCH_LEAD',
  CLEAR_LEAD: 'CLEAR_LEAD',
  UPDATE_LEAD: 'UPDATE_LEAD',
  FETCH_LEAD_NOTES: 'FETCH_LEAD_NOTES',
  ADD_LEAD_NOTES: 'ADD_LEAD_NOTES',
  DELETE_LEAD: 'DELETE_LEAD',
};
